export const deviationTypesMock = [
  { title: 'Antikvarisk vedlikehold', id: 'ct_52-47' },
  { title: 'Teknisk drift', id: 'ct_52-48' },
];
